<template>
  <div class="search">
    <div>
      <div class="position-relative jp-column">
        <el-image :src="mainBg" class="w-100 title-bg"></el-image>
        <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">Search</h4>
        <h1 class="jp-title">{{$t('search.title')}}</h1>
      </div>
    </div>
    <section>
      <div class="jp-line"></div>
      <div class="jp-column" :class="{ 'saarch_en': $i18n.locale === 'en' }">
        <span class="title" v-if="searchList.length !== 0">
         <span v-if="$i18n.locale === 'cn'">为您找到 {{searchList.length}} 个搜索结果</span>
         <span v-if="$i18n.locale === 'en'">{{searchList.length}} search results for you</span>
        </span>
        <span class="title no-information" v-if="searchList.length === 0">{{$t('search.noInfo')}}</span>
        <div class="filter-container text-left">
          <el-input :placeholder="$t('common.searchTitle')" v-model="searchQuery.title" @keyup.enter.native="search" class="input-with-select">
            <!-- <el-select
              slot="prepend"
              v-model="searchQuery.searchType"
              placeholder="请选择搜索类型"
              class="filter-item proposal-status"
              @change="search"
            >
              <el-option
                v-for="item in searchOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select> -->
            <el-button
              slot="append" 
              icon="el-icon-search" 
              @click="search">
            </el-button>
          </el-input>
        </div>
        <div class="search-content">
          <div v-for="(search, index) in searchList" :key="index" class="jp-card">
            <el-row :gutter="16" :type="rowType" align="middle" class="mt-3">
              <el-col :span="6" :xs="24"><img :src="search.thumbnail" alt="" class="w-100"></el-col>
              <el-col :span="18" :xs="24">
                <div class="text-left card-text">
                  <h4>{{search.title}}</h4>
                  <p>{{search.newsBriefing}}</p>
                  <time class="news-time" :datetime="search.createTime">{{search.createTime}}</time>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getNewsList } from '@/api/websiteApi';
import dateFormat from '@/filters/formatTime'

import mainBg from '@/assets/img/search_bg.png';
import newsImage from '@/assets/img/n1.jpeg';
import waves from '@/directive/waves';

export default {
  name: 'search',
  directives: {
    waves
  },
  data () {
    return {
      mainBg: mainBg,
      newsImage: newsImage,
      activeName: '',
      rowType: '',
      searchQuery: {
        searchType: 1,
        title: ''
      },
      searchOptions: [
        {
          id: 1,
          name: '新闻'
        }
      ],
      searchList: []
    }
  },
  watch: {
    '$i18n.locale'(val) {
      this.tabLang(val);
    }
  },
  created() {
    this.getWidth();
  },
  methods: {
    search() {
      if (this.searchQuery.title) {
        getNewsList(this.searchQuery).then(res => {
          _.forEach(res, item => {
            item.createTime = dateFormat.formatDate(new Date(item.createTime), 'yyyy-MM-dd')
            item.thumbnail = item.thumbnail.split('..')[1];
            item.thumbnail = this.imageBaseUrl + item.thumbnail;
          });
          this.searchList = res;
          this.tabLang(this.$i18n.locale)
        })
      } else {
        this.searchList = []
      }
    },
    tabLang(val) {
      _.forEach(this.searchList, item => {
        if (val === 'cn') {
          item.title = item.titleZh;
          item.newsBriefing = item.newsBriefingZh;
        }if (val === 'en') {
          item.title = item.titleEn;
          item.newsBriefing = item.newsBriefingEn;
        }if (val === 'jp') {
          item.title = item.titleJa;
          item.newsBriefing = item.newsBriefingJa;
        }
      });
    },
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
      } else {
        this.rowType = 'flex'
      }
    },
    moreOrganizational() {
      this.$router.push({ name: 'organizational' });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

section {
  h2 {
    font-size: 2rem;
  }
  .filter-container {
    width: 80%;
    margin: 0 auto;
  }

  .search-introduce {
    width: 1170px;
    margin: 0 auto;
    text-align: left;
    line-height: 2.25rem;
  }

  .jp-project-content {
    font-size: 1.4rem;
    .el-col {
      margin-bottom: 2.5rem;
    }
  }

  .news-time {
    color: #888;
    font-size: 0.8rem;
  }

  .search {
    // .jp-column {
    //   .no-information {
    //     left: calc((100% - 252px) / 2);
    //   }
    // }
    .saarch_en {
      .no-information {
        left: calc((100% - 403px) / 2);
      }
    }
    .search-content {
      margin-top: 2rem;
      h4 {
        color: #006ec3;
        font-size: 1.375rem;
      }
      p {
        padding: 0.5rem 0;
        font-size: 0.9375rem;
      }
    }
  }

  .filter-item {
    &.el-select {
      width: 12rem;
      margin-right: 4px;
    }

    &.el-input {
      width: 16rem;
      margin-right: 4px;
    }

    &.visibility {
      width: 12rem;
      margin-right: 4px;
    }

    &.el-date-editor {
      width: 24.2rem;
      margin-right: 4px;
    }

    &.el-select-tree {
      margin-right: 4px;
    }
  }
  @media (max-width: 768px) {
    .search {
      // .jp-column {
      //   .title {
      //     left: calc((100% - 263px) / 2);
      //   }
      //   .no-information {
      //     left: calc((100% - 180px) / 2);
      //   }
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/search.vue